import { useMemo } from "react";
import type { Performer } from "@shared/schema";

export function useOnStagePerformers(performers: Performer[]) {
  // Memoize the filtered and sorted performers to prevent unnecessary re-renders
  const onStagePerformers = useMemo(() => 
    performers
      .filter((performer) => 
        performer.status === 'on_stage' || performer.status === 'pending_removal'
      )
      .sort((a, b) => {
        // Three-tier sorting:
        // 1. First tier: pending_removal WITH a replacement (replacementName is set)
        const aHasReplacement = a.status === 'pending_removal' && a.replacementName;
        const bHasReplacement = b.status === 'pending_removal' && b.replacementName;
        
        if (aHasReplacement && !bHasReplacement) return -1;
        if (!aHasReplacement && bHasReplacement) return 1;
        
        // 2. Second tier: pending_removal WITHOUT a replacement
        const aPendingNoReplacement = a.status === 'pending_removal' && !a.replacementName;
        const bPendingNoReplacement = b.status === 'pending_removal' && !b.replacementName;
        
        if (aPendingNoReplacement && !bPendingNoReplacement) return -1;
        if (!aPendingNoReplacement && bPendingNoReplacement) return 1;
        
        // 3. Third tier: regular on_stage performers
        // Sort alphabetically by name within each tier
        return a.name.localeCompare(b.name);
      }),
    [performers]
  );

  return onStagePerformers;
}